<template>
    <div class="aprh__authentication display--flex page--all background--default">
        <img
            :src="require('@/assets/images/logo.png')"
            alt="Aprh"
            class="aprh__authentication__logo"
            aria-label="Aprh"
        />
        <base-form
            class="aprh__authentication__form"
            :id="$route.name"
            :submissionType="submissionTypes[ $route.name ]"
        >
            <base-card
                class="card--authentication"
                type="authentication"
            >
                <template #card__title >
                    <icon-padlock class="aprh__authentication__form__padlock display--block "/>
                    <span class="aprh__authentication__form__title capitalize display--block">
                        {{ $t(`authentication.${$route.name}`) }}
                    </span>
                </template>
                <template #card__body >
                    <transition
                        name="fade-authentication"
                        mode="out-in"
                        @enter="enter"
                    >
                    <router-view
                        class="aprh__authentication__form__element"
                        :settings="{
                            id: $route.name,
                            submissionType: submissionTypes[ $route.name ]
                        }"
                        :input="() => import( /* webpackChunkName: 'BaseField' */ '@/components/bundles/fields/BaseField' )"
                        :helpers="helpers"
                    />
                    </transition>
                </template>
            </base-card>

            <template v-if="!helpers.isSuccessForgot">
                <submission-handler>
                    <base-button
                        type="submit"
                        class="aprh__authentication__form__button background--blue color--white display--block"
                        v-html="$t(`${ settings[ $route.name ].button.text }`)"
                    />
                </submission-handler>
                <router-link
                    :to="settings[ $route.name ].link.route"
                    activeClass="active"
                    class="aprh__authentication__form__anchor display--block color--blue capitalize"
                >
                    {{ $t(`${ settings[ $route.name ].link.text }`) }}
                </router-link>
            </template>
        </base-form>
    </div>
</template>

<script>
// Composition API
import { reactive, ref, watch } from '@vue/composition-api';

// store
// eslint-disable-next-line
import { mapState } from '@/hooks/use-store';

// hooks
import { authenticationStructure } from '@/hooks/use-data';

export default {
    ...authenticationStructure,
    setup ( _, { root }) {
        // obtenção & update da route.
        const route = ref( root.$route.name );
        const previousRoute = ref();

        // obtenção dos helpers da store.
        const helpers = mapState({ module: 'storePayload', key: 'helpers' });

        watch( () => root.$route,
            newRoute => {
                route.value = newRoute.name;
                previousRoute.value = newRoute.name === 'login' ? 'forgot' : 'login';
            });

        // animação de transição de página.
        const enter = element => {
            // definção dos valores default de cada página.
            const heights = {
                login: {
                    attribute: 'maxHeight',
                    value: '228px'
                },
                forgot: {
                    attribute: 'minHeight',
                    value: '115px'
                },
                reset: {
                    attribute: 'minHeight',
                    value: '256px'
                }
            };

            // obtenção dos valores da página actual.
            const { attribute, value } = heights[route.value];

            // definição do atributo com o valor da rota anterior.
            element.style[attribute] = heights[previousRoute.value]?.value;

            // definição do atributo com o valor da rota actual.
            setTimeout( () => { element.style[attribute] = value; });
        };

        // tipos de submissão conforme a página.
        const submissionTypes = reactive({
            login: 'processLogin',
            reset: 'resetPassword',
            forgot: 'forgotPassword'
        });

        const settings = reactive({
            login: {
                button: {
                    text: 'global.entry'
                },
                link: {
                    route: '/authentication/forgot',
                    text: 'authentication.forgotPassword'
                }
            },
            forgot: {
                button: {
                    text: 'authentication.forgot'
                },
                link: {
                    route: '/authentication/login',
                    text: 'global.cancel'
                }
            },
            reset: {
                button: {
                    text: 'authentication.forgot'
                },
                link: {
                    route: '/authentication/login',
                    text: 'global.cancel'
                }
            }
        });

        return {
            submissionTypes,
            settings,
            enter,
            helpers
        };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    .fade-authentication-enter-active {
        @include transition(
            opacity .3s ease-in-out .15s,
            min-height .3s ease-in-out,
            max-height .3s ease-in-out
        );
        overflow: hidden;
    }

    .fade-authentication-enter,
    .fade-authentication-leave-active {
        opacity: 0
    }

    // =============================================================================
    // Style
    // =============================================================================
    .aprh {
        &__authentication {
            @include position-grid( center, center );
            flex-direction: column;
            &__form {
                max-width: 434px;
                width: 100%;
                &__field {
                    &:not(:last-child) {
                        margin-bottom: 30px;
                    }
                    &__input {
                        height: 40px;
                    }
                    &--margin {
                        margin-top: 25px;
                    }
                }
                &__anchor {
                    text-align: center;
                    @include typography-specs( 16px, 24px );
                    margin-top: 16px;
                }
                &__description {
                    @include typography-specs( 15px, 22px );
                    margin-bottom: 18px;
                    text-align: center;
                    &__email {
                        font-weight: 500;
                    }
                }
                &__back {
                    margin: 5px 0 0;
                }
                &__button {
                    margin: 33px auto 0;
                    width: 241px !important;
                    @include typography-specs( 18px, 26px, 700 );
                }
                &__resend-link {
                    height: auto !important;
                    background: transparent;
                }
                &__padlock {
                    margin: 16px auto 18px;
                }
            }
            &__logo {
                @include dimensions( 100px, auto );
                margin-bottom: 40px;
            }
        }
    }
</style>